module.exports = __webpack_public_path__ + "static/media/io.550553a7.svg";